module.exports = window.crypto;


//////////////////
// WEBPACK FOOTER
// ./node_modules/randomhex/src/browser.js
// module id = 145
// module chunks = 0